import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { Trash2, Edit, Plus } from "react-feather";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
} from "reactstrap";
import { Btn, H5, Spinner } from "../../../AbstractElements";
import axios from "axios";
import CommonModal from "../../../_core/Ui-kits/Modals/common/modal";
import Dropzone1 from "../../Bonus UI/Dropzones/Dropzone1";
import SingleSelect from "../../SingleSelect/SingleSelect";

const user_options = ["Name", "Province", "District", "Status"];

const FilterComponent = ({
  filterText,
  onFilter,
  onClear,
  userOption,
  setSelectedUserOption,
  t
}) => (
  <div style={{ display: "flex", flexDirection: "row", width: 'auto', gap: 10 }}>
    <SingleSelect
      options={user_options}
      selectedOption={userOption}
      onChange={setSelectedUserOption}
    />
    {userOption === 'Status' ?
      <SingleSelect
        options={["Submitted", "Send For Edits", "Accepted", "Rejected", "Uploaded"]}
        selectedOption={filterText}
        onChange={(e) => onFilter({ target: { value: e } })}
      />
      :
 <>
         <input
            className="form-control"
            placeholder={userOption === 'District'? t("Filter by District") : userOption === 'Name'? t("Filter by Name") : userOption === 'Province'? t("Filter by Province") : t("Filter by Status") }
            aria-label="Search Input"
            style={{ width: "250px", paddingLeft: "5px" }}
            name="phone"
            id="search"
            type="text"
            value={filterText}
            onChange={onFilter}
          />
          <Btn attrBtn={{ onClick: onClear }} type="button">
            X
          </Btn>
        </>
    }
  </div>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [modal, setModal] = useState(false);
  const [agmPrice, setAgmPrice] = useState(0);
  const [modal2, setModal2] = useState(false);
  const [newMember, setNewMember] = useState(0);
  const [renewMember, setRenewMember] = useState(0);
  const { t } = useTranslation();
  const [userOption, setSelectedUserOption] = useState("Name");
  const pres = localStorage.getItem("pres");
  const [filteredItems, setFilteredItems] = useState();
  const [file, setFile] = useState();
  const toggle = () => setModal(!modal);

  const toggle2 = () => setModal2(!modal2);
  const [data, setData] = useState();
  useEffect(() => {
    handle_get_firms();
    handle_get_dates();
  }, []);

  const getUploadParams3 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus3 = ({ meta, file }, status) => {
    setFile(file);
  };

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/firms", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        const firms = response2?.data?.data?.firms;
        if (pres === "false") {
          setData(firms);
          setFilteredItems(firms);
        } else {
          const filteredFirms = firms?.filter((item) => item?.status === 3);
          setData(filteredFirms);
          setFilteredItems(filteredFirms);
        }
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error.response.data.message || "An error occurred");
      } else if (error.request) {
        console.error("Error request:", error.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error.message);
        toast.error(error.message);
      }
    }
  };

  const handle_get_dates = async () => {
    try {
      const response2 = await axios.get("https://api-portal.nada.org.np/api/proxies/proxy/dates", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response2?.data?.success) {
        setRenewMember(response2?.data?.data?.dates?.[0]?.renew);
        setNewMember(response2?.data?.data?.dates?.[0]?.new_mem);
        setAgmPrice(response2?.data?.data?.dates?.[0]?.current_agm);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };

  const handle_bulk_upload = async (e) => {
    e.preventDefault();
    if (file) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post("https://api-portal.nada.org.np/api/firms/bulk", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response?.data?.success) {
            //setData(response?.data?.data?.firms);
            toast.success("Bulk upload successful!");
            setLoading(false);
            handle_get_firms();
            toggle2();
          }
          setLoading(false);
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || "An error occurred");
          setLoading(false);
          console.error(error);
        });
    } else {
      toast.warning("No file uploaded yet!");
    }
  };
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Btn attrBtn={{ color: "danger", onClick: handleDelete }} key="delete">
        Delete
      </Btn>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to delete:\r ${selectedRows.map((r) => r.name)}?`
      )
    ) {
      setToggleCleared(!toggleCleared);
      setData(differenceBy(data, selectedRows, "name"));
      toast.success("Successfully Deleted !");
    }
  };

  function ComponentEdit({ row }) {
    return (
      <span style={{ display: "flex", flexDirection: "row", gap: 10 }}>
        <div
          onClick={() => {
            navigate("/firm/edit", { state: { id: row?.id } });
          }}
        >
          <Edit />
        </div>
        {/*<a href="#javascript" onClick={() => handleDelete(row.id)}>
          <Trash2 color="#e52727" />
        </a>*/}
      </span>
    );
  }

  const handleAddNewClick = () => {
    navigate("/firm/add");
  };


  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);


  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        userOption === "Name"
          ? data?.filter((item) =>
              item?.name_of_firm
                ?.toLowerCase()
                ?.includes(filterText?.toLowerCase())
            )
          : userOption === "Province"
          ? data?.filter((item) =>
              item?.province?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "District"
          ? data?.filter((item) =>
              item?.district?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : data?.filter((item) =>
            String(item?.status === 1? 'Submitted' : item?.status === 2?  'Send For Edits' : item?.status === 3?  'Accepted' : item?.status === 4?  'Rejected' : item?.status === 10?  'Uploaded' : 'Send For Edits')?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
      );
    }

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        t={t}
        userOption={userOption}
        setSelectedUserOption={setSelectedUserOption}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle, userOption]);

  const renderStatusBadge = (status) => {
    switch (status) {
      case 1:
        return <Badge color="primary">Submitted</Badge>;
      case 2:
        return <Badge color="secondary">Send For Edits</Badge>;
      case 3:
        return <Badge color="success">Accepted</Badge>;
      case 4:
        return <Badge color="danger">Rejected</Badge>;
      case 10:
          return <Badge color="info">Uploaded</Badge>;
      default:
        return <Badge color="warning">Send For Edits</Badge>;
    }
  };

  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };

  const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name"),
      selector: (Row) => Row["name_of_firm"],
      sortable: true,
      center: true,
    },
    {
      name: t("Pan Number"),
      selector: (Row) => Row["pan_number"],
      sortable: true,
      center: true,
    },
    {
      name: t("Type of Organization"),
      selector: (Row) => Row["type_of_organization"],
      sortable: true,
      center: true,
      minWidth: "200px", // Set a minimum width
      maxWidth: "600px", // Set a maximum width
      wrap: true, // Ensure text wraps within the cell
    },
    {
      name: t("Membership Status"),
      selector: (Row) => renderStatusBadge2(Row["membership_status"]),
      sortable: true,
      center: true,
    },
    {
      name: t("Status"),
      selector: (Row) => renderStatusBadge(Row["status"]),
      sortable: true,
      center: true,
    },
    pres === "false"
      ? { name: t("Actions"), cell: (row) => <ComponentEdit row={row} /> }
      : "",
  ];

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const renderStatusBadge2 = (status) => {
    switch (status) {
      case 1:
        return <Badge color="danger">Inactive</Badge>;
      case 2:
        return <Badge color="success">Active</Badge>;
      default:
        return <Badge color="danger">Inactive</Badge>;
    }
  };

  const handle_membership_fees = async (e) => {
    e.preventDefault();
    if (
      (newMember !== 0 && newMember !== null ) &&
      (renewMember !== 0 && renewMember !== null ) &&
      (agmPrice !== 0 && agmPrice !== null )
    ) {
      try {
        setLoading2(true);
        const response2 = await axios.put(
          `https://api-portal.nada.org.np/api/proxies/proxy/dates`,
          {
            new_mem: newMember,
            renew: renewMember,
            current_agm: agmPrice
          },
          {
            headers: {
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
              'Authorization': `Bearer ${token}`,
            },
          }
        );
        if (response2?.data?.success) {
          setLoading(false);
          toast.success("membership fees updated successfully successfully.");
          toggle();
          //setData(response2?.data?.data?.firms);
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          console.error("Error response:", error?.response);
          toast.error(error?.response?.data?.message || "An error occurred");
        } else if (error?.request) {
          console.error("Error request:", error?.request);
          toast.error("No response received from server");
        } else {
          console.error("Error message:", error?.message);
          toast.error(error?.message);
        }
      }
    } else {
      toast.error("Both fields are required");
    }
  };

  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Firms")}</H5>
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <Btn
                    attrBtn={{ color: "secondary", onClick: toggle2 }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("Bulk Upload")}
                  </Btn>
                  <Btn
                    attrBtn={{ color: "secondary", onClick: toggle }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("Set Membership Fees")}
                  </Btn>
                  <Btn
                    attrBtn={{ color: "primary", onClick: handleAddNewClick }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("Add New")}
                  </Btn>
                </div>
              </CardHeader>
              <CardBody>
                {data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    //selectableRows
                    //contextActions={contextActions}
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
        isOpen={modal}
        toggle={toggle}
        //size={props.size}
        centered
      >
        <ModalHeader toggle={toggle}>{t("Set Membership Fees")}</ModalHeader>
        <ModalBody
        //className={props.bodyClass}
        style={{
          flexDirection: 'column',
          display: 'flex', gap: 20,
          //alignItems: 'center',
          justifyContent:'flex-start'
        }}
        >
          <div
          style={{ flexDirection: 'row', display: 'flex', gap: 20, alignItems: 'center', justifyContent:'space-between'}}
        >
        <Label className="form-label">{t("New Membership Price")}</Label>
        <input
                  style={{ width: 150 }}
                  className="form-control"
                  name="phone"
                  type="number"
                  placeholder={t("Set new membership price")}
                  value={newMember}
                  onChange={(e) => setNewMember(e.target.value)}
                  //{...register("phone", { required: true })}
                />
        </div>
        <div
          style={{ flexDirection: 'row', display: 'flex', gap: 20, alignItems: 'center', justifyContent:'space-between'}}
        >
        <Label className="form-label">{t("Renewal Membership Price")}</Label>
        <input
        style={{ width: 150 }}
                  className="form-control"
                  name="phone"
                  type="number"
                  placeholder={t("Set renew membership price")}
                  value={renewMember}
                  onChange={(e) => setRenewMember(e.target.value)}
                  //{...register("phone", { required: true })}
                />
        </div>
        <div
          style={{ flexDirection: 'row', display: 'flex', gap: 20, alignItems: 'center', justifyContent:'space-between'}}
        >
        <Label className="form-label">{t("Annual General Meeting Price")}</Label>
        <input
        style={{ width: 150 }}
                  className="form-control"
                  name="phone"
                  type="number"
                  placeholder={t("Set agm price")}
                  value={agmPrice}
                  onChange={(e) => setAgmPrice(e.target.value)}
                  //{...register("phone", { required: true })}
                />
        </div>
        </ModalBody>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle, height: 65 }}>
            {t("Close")}
          </Btn>

          {loading ? (
            <div className="loader-box">
              <Spinner attrSpinner={{ className: "loader-2" }} />
            </div>
          ) : (
            <Btn
              attrBtn={{
                color: "primary",
                onClick: handle_membership_fees,
                outerHeight: 65,
              }}
            >
             {t("Update")}{" "}
            </Btn>
          )}
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={modal2}
        toggle={toggle2}
        //size={props.size}
        centered
      >
        <ModalHeader
        toggle={toggle2}
        >{t("Bulk Upload Firms")}</ModalHeader>
        <ModalBody
        //className={props.bodyClass}
        >
          <div>
            {" "}
            <Label className="form-label">{t("Upload CSV File")}</Label>
            <Dropzone1
              //getUploadParams={getUploadParams3}
              accept=".csv,text/csv"
              handleChangeStatus={handleChangeStatus3}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Btn attrBtn={{ color: "secondary", onClick: toggle2, height: 65 }}>
            {t("Close")}
          </Btn>

          {loading2 ? (
            <div className="loader-box">
              <Spinner attrSpinner={{ className: "loader-2" }} />
            </div>
          ) : (
            <Btn
              attrBtn={{
                color: "primary",
                onClick: (e) => handle_bulk_upload(e),
                outerHeight: 65,
              }}
            >
             {t("Upload")}{" "}
            </Btn>
          )}
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default DataTablesContain;
